<template>
    <register-form
        @show-modal="showModal"
        :onRegister="handleRegister"
        :onVerifyEmail="handleVerifyEmail"
        :timer="timer"
        :onConfirmSmsCode="confirmSmsCode"
        :onSendSmsCode="registerSendSmsCode"
        :regions="regions"
        :orgTypes="orgTypes"
    />
</template>
<script>
    import { mapActions, mapState } from 'vuex';
    import debounce from 'debounce-promise';
    import RegisterForm from './RegisterForm';
    import { metrika, ga } from '../../../services/analytics';
    import { verificationEmail } from '../../../services/api/account';

    const handleVerifyEmail = debounce(verificationEmail, 500);

    export default {
        name: 'register-form-container',
        components: {
            RegisterForm,
        },
        methods: {
            ...mapActions('auth', [
                'sendSmsCode',
                'confirmSmsCode',
                'startSmsTimer',
                'register',
            ]),
            ...mapActions('modal', ['show']),

            handleVerifyEmail,

            handleRegister(values) {
                const { refcode } = this.$route.query;

                const extraValues = refcode
                    ? { refcode }
                    : {};

                return this.register({ ...values, ...extraValues })
                    .then((res) => {
                        metrika.reachGoal('demosregilead');
                        ga.dataLayer.push({
                            event: 'GA_event',
                            eventCategory: 'Knopka',
                            eventAction: 'Regaok',
                        });

                        return res;
                    });
            },

            registerSendSmsCode(phone) {
                return this.sendSmsCode({
                    form: 'register',
                    phone,
                });
            },
            showModal() {
                this.show('userAgreement');
            },
        },
        computed: {
            ...mapState('regions', ['regions']),
            ...mapState('orgTypes', ['orgTypes']),
            ...mapState('auth', {
                timer: ({ register }) => {
                    return register.seconds;
                },
            }),
        },
        created() {
            this.startSmsTimer({ form: 'register' });
        }
    }
</script>



// WEBPACK FOOTER //
// RegisterFormContainer.vue?c2ce3378